import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: ${({ theme }) => theme.spacings.spacing_xxl};
`;

export const Title = styled.div`
  ${({ theme }) => theme.textStyles.title2};
  @media only screen and (max-width: 560px) {
    font-size: 15px;
  }
`;

export const Contents = styled.div`
  ${({ theme }) => theme.textStyles.content2};

  @media only screen and (max-width: 560px) {
    font-size: 15px;
  }
`;
